// extracted by mini-css-extract-plugin
export var container = "_e1-1";
export var cornerButtonContainer = "_e1-6";
export var disabled = "_e1-2";
export var dragActive = "_e1-3";
export var fileContainer = "_e1-5";
export var hiddenInput = "_e1-4";
export var widthContainer = "_e1-0";